import { featuredProjects } from '../../../mocks/projects';

const FeaturedProjects = () => {
  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <span className="inline-block px-4 py-2 bg-white rounded-full text-xs font-medium text-gray-600 uppercase tracking-wider mb-6">
            Recent Werk
          </span>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'serif' }}>
            RENOVATIE<br />
            EXCELLENTIE
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {featuredProjects.map((project, index) => (
            <div
              key={project.id}
              className={`bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer ${
                index === 1 ? 'md:-mt-10' : ''
              }`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'serif' }}>
                  {project.name}
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  {project.description}
                </p>
                <span className="inline-block px-4 py-2 bg-gray-100 rounded-full text-xs font-medium text-gray-700">
                  {project.category}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;